<template>
  <div>
    <!-- Titlebar
================================================== -->
    <div id="titlebar" class="gradient">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h2>Register</h2>

            <!-- Breadcrumbs -->
            <nav id="breadcrumbs" class="dark">
              <ul>
                <li><a href="#">Home</a></li>
                <li>Register</li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>

    <!-- Page Content
================================================== -->
    <div class="container">
      <div class="row">
        <div class="col-xl-5 offset-xl-3">
          <div class="login-register-page">
            <!-- Welcome Text -->
            <div class="welcome-text">
              <h3 style="font-size: 26px">Let's create your account!</h3>
              <span
                >Already have an account?
                <router-link tag="a" to="/login">Log In!</router-link></span
              >
            </div>

            <!-- Form -->
            <form id="register-account-form">
              <div class="input-with-icon-left">
                <i class="icon-feather-user"></i>
                <input
                  type="text"
                  class="input-text with-border"
                  name="fullname-register"
                  id="fullname-register"
                  placeholder="Full name"
                  required
                  v-model="userData.name"
                />
              </div>

              <div class="input-with-icon-left">
                <i class="icon-material-baseline-mail-outline"></i>
                <input
                  type="email"
                  class="input-text with-border"
                  name="emailaddress-register"
                  id="emailaddress-register"
                  placeholder="Email Address"
                  required
                  v-model="userData.email"
                />
              </div>

              <div
                class="input-with-icon-left"
                title="Should be at least 8 characters long"
                data-tippy-placement="bottom"
              >
                <i class="icon-material-outline-lock"></i>
                <input
                  type="password"
                  class="input-text with-border"
                  name="password-register"
                  id="password-register"
                  placeholder="Password"
                  required
                  v-model="userData.password"
                />
              </div>
            </form>
            <div>
              <label class="mb-1"
                >You agree to the {{ DOMAIN_NAME
                }}<a href="#"> User Agreement</a>,
                <a href="#">Privacy Policy</a>, and
                <a href="#">Cookie Policy</a>.</label
              >
            </div>
            <!-- Error Message -->
            <div class="notification error closeable" v-if="errorMessage">
              <p v-text="errorMessage"></p>
            </div>
            <!-- #Error Message -->

            <!-- Button -->
            <button
              class="
                button
                full-width
                button-sliding-icon
                ripple-effect
                margin-top-10
                text-uppercase
              "
              type="submit"
              :disabled="registerButtonDisabled"
              @click="register()"
            >
              Agree & Join <i class="icon-material-outline-arrow-right-alt"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Spacer -->
    <div class="margin-top-70"></div>
    <!-- Spacer / End-->
  </div>
</template>

<script>
/* eslint-disable no-console */
import { postCall } from "../../../core/services/http.service";
import { REGISTER } from "../../../core/config/endpoints/auth";
import { DOMAIN_NAME } from "../../../plugins/config/constants";
import { setToken } from "../../../plugins/handlers";

export default {
  name: "Register",

  data() {
    return {
      DOMAIN_NAME: DOMAIN_NAME,
      errorMessage: null,
      token: null,
      registerButtonDisabled: false,
      userData: {
        name: "fredrcik",
        email: "fred@gmail.com",
        password: "password@123",
      },
    };
  },

  methods: {
    register() {
      if (this.userData.email.length < 5)
        return (this.errorMessage = "Provide a valid email");
      if (this.userData.name.length < 3)
        return (this.errorMessage = "Provide a valid name");
      if (this.userData.password.length < 6)
        return (this.errorMessage = "Provide password");

      postCall(REGISTER, this.userData)
        .then((response) => {
          this.token = response.data.data.token;
          setToken(this.token);
        })
        .catch((error) => {
          this.registerButtonDisabled = false;
          if (!error.response) return "Try again";
          if (!error.response.data) return "Try again";
          let errorsBag = error.response.data;
          if (!errorsBag.errors) return (this.errorMessage = errorsBag.message);

          let errorMessage = errorsBag.errors;
          let errorKey = Object.keys(errorMessage)[0];
          return (this.errorMessage = `Invalid ${errorKey}`);
        })
        .finally(() => {
          if (!this.token) return false;

          // let lastUrl = localStorage.getItem("from");
          // if (lastUrl && lastUrl != "/login") {
          //   return this.$router.push(lastUrl);
          // }

          return this.$router.push("/login");
        });
    },
  },
};
</script>

<style scoped></style>
